import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Logo
const LOGO_URL = "https://customer-assets.emergentagent.com/job_team-automation-hub/artifacts/43177upw_agents2go_white.svg";

// Navbar Component
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`} data-testid="navbar">
      <div className="container-custom flex items-center justify-between">
        <a href="/" data-testid="nav-logo">
          <img src={LOGO_URL} alt="agents2go" className="logo-img" />
        </a>
        <button 
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
        >
          <ArrowLeft size={20} />
          <span>Zurück zur Startseite</span>
        </button>
      </div>
    </nav>
  );
};

// Main Erstgespraech Page Component
function ErstgespraechPage() {
  const meetingPoints = [
    "Vorstellung von agents2go",
    "Live Demo unserer digitalen Mitarbeiter",
    "Analyse der größten Automatisierungspotenziale"
  ];

  return (
    <div className="erstgespraech-page">
      <Navbar />
      
      {/* Section 1 - Erstgespräch Info (Dark) */}
      <section className="eg-hero section-dark">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="eg-headline">
              Der erste Schritt: ein unverbindliches <span className="gradient-text">Erstgespräch</span>
            </h1>
            
            <p className="eg-text">
              Der Einstieg in die Zusammenarbeit beginnt mit einem kostenlosen und unverbindlichen Erstgespräch.
            </p>
            
            <p className="eg-subtext">
              Wir kommen zu Ihnen ins Unternehmen und zeigen Ihnen, wie digitale Mitarbeiter konkret eingesetzt werden können.
            </p>
            
            <div className="eg-steps">
              {meetingPoints.map((point, index) => (
                <div key={index} className="eg-step">
                  <div className="eg-step-number">{index + 1}</div>
                  <span className="eg-step-text">{point}</span>
                </div>
              ))}
            </div>
            
            <div className="eg-notice">
              <p>Das Gespräch ist kostenlos und unverbindlich.</p>
            </div>

            <div className="cta-box">
              <a
                href="mailto:kontakt@agents2go.com?subject=Kostenloses%20Erstgespräch%20vereinbaren"
                className="gradient-btn"
              >
                <span className="cta-text-desktop">Kostenloses Erstgespräch vereinbaren</span>
                <span className="cta-text-mobile">Gratis Termin buchen</span>
              </a>
              <p className="cta-subtext">Dauer ca. 30–45 Minuten.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2 - AI Workshop (Light) */}
      <section className="eg-workshop section-light section-padding">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="eg-workshop-headline">
              Wo liegt in Ihrem Unternehmen der <span className="gradient-text">größte Hebel</span>?
            </h2>
            
            <p className="eg-workshop-text">
              Im AI-Potential Workshop identifizieren wir gemeinsam den digitalen Mitarbeiter mit dem größten Nutzen.
            </p>

            <div className="cta-box">
              <a
                href="mailto:kontakt@agents2go.com?subject=Kostenloses%20Erstgespräch%20vereinbaren"
                className="gradient-btn"
              >
                <span className="cta-text-desktop">Kostenloses Erstgespräch vereinbaren</span>
                <span className="cta-text-mobile">Gratis Termin buchen</span>
              </a>
              <p className="cta-subtext">Dauer ca. 30–45 Minuten.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer section-dark">
        <div className="container-custom text-center">
          <img src={LOGO_URL} alt="agents2go" className="logo-img mx-auto mb-6" />
          <p className="text-white/60">
            © 2026 agents2go · Ein Produkt von{" "}
            <a href="https://tk100x.com" target="_blank" rel="noopener noreferrer" className="footer-link">TK100X</a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default ErstgespraechPage;
